module.exports = __webpack_public_path__ + "img/q-8-1@2x.096e6722.png";